import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import { defineMessages, FormattedMessage, injectIntl } from "react-intl";
import { PureComponent } from "react";
import { AgentsLogin, AgentsReport, PopupPrivacy } from "@witbooking/react-components";
import { getAgentReport } from "./../../utils/witbookingApi";
import { FooterMenu } from "~/components";
import classnames from "classnames";
import styles from "./Footer.scss";
import styled from "styled-components";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  hideDefaultPrivacyPolicySelector,
  privacyPolicySelector,
} from "../../containers/Checkout/selectors";
import { redirectUrl } from "../../utils/misc";

const AgentContainer = styled.div`
  display: flex;
  justify-content: center;
`;
const PointContainer = styled.div`
  display: none;
  @media (min-width: 480px) {
    display: block;
  }
`;
const DivAgentEmail = styled.div`
  font-size: 11px;
  color: #908f96;
`;
const AgentLogging = styled.button`
  border: 0;
  font-size: 11px;
  font-weight: 700;
  color: #908f96;
  text-decoration: underline;
  outline: 0;
`;
const AgentLogout = styled.button`
  border: 0;
  font-size: 11px;
  background-color: white;
  font-weight: 700;
  color: #908f96;
  text-decoration: underline;
  outline: 0;
  margin-left: 10px;
`;
const AgentActivity = styled.button`
  border: 0;
  font-size: 11px;
  font-weight: 700;
  color: #908f96;
  text-decoration: underline;
  outline: 0;
  margin-left: 10px;
`;

// TODO Samir says Simplify the removeURLParameter function
function removeURLParameter(url, parameter) {
  let newURL = "";
  const urlparts = url.split("?");
  if (urlparts.length >= 2) {
    const prefix = encodeURIComponent(parameter) + "=";
    const pars = urlparts[1].split(/[&;]/g);

    for (let looper = pars.length; looper-- > 0; ) {
      if (pars[looper].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(looper, 1);
      }
    }

    newURL = urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
  }
  return newURL;
}

const msgs = defineMessages({
  viewMap: {
    id: "footer.additional_info.viewMap",
    description: "View map",
    defaultMessage: "view map",
  },
  logginAgency: {
    id: "footer.link.agencyEntry",
    description: "Agency Entry text",
    defaultMessage: "Entry agencies",
  },
  logoutAgency: {
    id: "footer.link.signOut",
    description: "Agency Entry text",
    defaultMessage: "Sign off",
  },
  activityAgency: {
    id: "footer.link.myActivity",
    description: "Agency Entry text",
    defaultMessage: "My activity",
  },
  privacyPolicy: {
    id: "footer.link.privacyPolicy",
    description: "Privacy policy text",
    defaultMessage: "Privacy policy",
  },
});

class Footer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      agentRespond: null,
    };
  }
  infoArr = ["address", "city", "country", "map", "phone", "contactEmail", "privacyPolicy"];

  accesAgentState(email) {
    const parameters = "isAgent=1&affiliate=" + email + "&messageCode=modalAgente";
    const url =
      window.location.href + window.location.href.includes("?")
        ? "&" + parameters
        : "?" + parameters;
    redirectUrl(url);
    this.props.handleCloseModal();
  }

  handleAgentLoggin = () => {
    this.props.handleModalContent(
      <AgentsLogin handleSubmit={this.accesAgentState} buttonClose={this.props.handleCloseModal} />,
      {
        hideCloseButton: true,
      }
    );
  };

  handleAgentActivity = height => {
    this.props.handleModalContent(
      <AgentsReport
        handleSubmit={this.handleEndPointCall}
        handleCloseModal={() => {
          this.props.handleCloseModal();
        }}
        success={this.state.agentRespond}
      />,
      {
        hideCloseButton: true,
        className: "agentContent",
        styles: {
          content: {
            maxWidth: "830px",
            minHeight: height,
            overflow: "hidden",
          },
        },
      }
    );
  };
  handleAgentLogout = () => {
    let newhref = window.location.href;
    newhref = removeURLParameter(newhref, "isAgent");
    newhref = removeURLParameter(newhref, "affiliate");
    newhref = removeURLParameter(newhref, "messageCode");
    redirectUrl(newhref);
  };

  callAgentActivity = height => {
    this.handleAgentActivity(height);
  };

  handleClickAgentActivity = () => {
    this.setState({ agentRespond: null }, () => this.callAgentActivity("580px"));
  };

  handleEndPointCall = ({ dateSearchCriteria, startDate, endDate }) => {
    getAgentReport({}, { dateSearchCriteria, startDate, endDate, email: this.props.affiliate })
      .then(value => {
        switch (value.response) {
          case "sent":
          case "queued":
          case "scheduled":
            this.setState({ agentRespond: true }, () => this.callAgentActivity("250px"));
            break;
          default:
            this.setState({ agentRespond: false }, () => this.callAgentActivity("580px"));
            break;
        }
      })
      .catch(value => {
        if (value.response !== "sent") {
          this.setState({ agentRespond: false }, () => this.handleAgentActivity("580px"));
        }
      });
  };

  render() {
    const {
      propertyName,
      handleMap,
      propertyContact,
      showLanguage,
      showCurrency,
      locale,
      currency,
      locales,
      currencies,
      onLanguageChange,
      onCurrencyChange,
      promoCode,
      toggleBookingFormSummary,
      showAgentLogin,
      privacyPolicy,
      handleCloseModal,
      handleModalContent,
      hideDefaultPrivacyPolicy,
    } = this.props;

    const handlePrivacyPolicy = () => {
      handleModalContent(
        <div>
          <PopupPrivacy
            data={{ propertyName, reverse: false, privacyPolicy }}
            locale={locale}
            closeWindow={handleCloseModal}
            hideDefaultPrivacyPolicy={hideDefaultPrivacyPolicy}
          />
        </div>,
        {
          hideCloseButton: true,
          modalWidth: "700px",
        }
      );
    };

    return (
      <div className={classnames("wbkv9-Footer", "wbkv9-RoomSelection-Footer", styles.footer)}>
        <FooterMenu
          showLanguage={showLanguage}
          showCurrency={showCurrency}
          locale={locale}
          currency={currency}
          locales={locales}
          currencies={currencies}
          onLanguageChange={onLanguageChange}
          onCurrencyChange={onCurrencyChange}
          promoCode={promoCode}
          toggleBookingFormSummary={toggleBookingFormSummary}
        />

        <div className={styles.footerInfoContainer}>
          <div className={styles.footerLeftInfo}>
            <span>{propertyName}</span>
            <span>
              {this.infoArr.map((value, idx) => {
                const separator = value === "address" || value === "phone" ? " // " : " · ";
                switch (value) {
                  case "map":
                    return (
                      <span key={idx} className="wbkv9-Footer-map">
                        {propertyContact.get("latitude") !== undefined &&
                          propertyContact.get("longitude") !== undefined &&
                          propertyContact.get("latitude") !== null &&
                          propertyContact.get("longitude") !== null && (
                            <span>
                              {" "}
                              ·{" "}
                              <a
                                className={classnames("wbkv9-Checkout-viewMap", styles.viewMap)}
                                onClick={handleMap}>
                                <FormattedMessage {...msgs.viewMap} />
                              </a>
                            </span>
                          )}
                      </span>
                    );
                  case "phone":
                    return (
                      <span key={idx} className="wbkv9-Footer-phone-container">
                        <span
                          className={classnames(
                            styles.phoneDesktopContainer,
                            "wbkv9-Footer-phone-desktop"
                          )}>
                          {separator + this.props.propertyContact.get(value)}
                        </span>
                        <span className={styles.phoneMobileContainer}>
                          {separator}
                          <a
                            className="wbkv9-Footer-phone-mobile"
                            href={`tel:+${this.props.propertyContact.get(value)}`}>
                            {this.props.propertyContact.get(value)}
                          </a>
                        </span>
                      </span>
                    );
                  case "privacyPolicy":
                    return (
                      <span className={`wbkv9-Footer-${value}`}>
                        {separator}
                        <span
                          onClick={handlePrivacyPolicy}
                          className={styles.privacyPoliceContainer}>
                          {this.props.intl.formatMessage(msgs.privacyPolicy)}
                        </span>
                      </span>
                    );
                  default:
                    return (
                      propertyContact.get(value) && (
                        <span key={idx} className={`wbkv9-Footer-${value}`}>
                          {separator + this.props.propertyContact.get(value)}
                        </span>
                      )
                    );
                }
              })}
            </span>
            <div className={classnames("wbkv9-Footer-powered", styles.powered)}>
              <div>
                powered by{" "}
                <a
                  className={styles.poweredByLink}
                  href="http://www.witbooking.com"
                  target="_blank">
                  Witbooking
                </a>
              </div>
              {showAgentLogin && (
                <div>
                  <AgentContainer>
                    <PointContainer>&nbsp;·&nbsp;</PointContainer>
                    {this.props.isAgentLogged === "1" ? (
                      <AgentContainer>
                        <DivAgentEmail>{this.props.affiliate}</DivAgentEmail>
                        <AgentActivity onClick={this.handleClickAgentActivity}>
                          <FormattedMessage {...msgs.activityAgency} />
                        </AgentActivity>
                        <AgentLogout onClick={this.handleAgentLogout}>
                          <FormattedMessage {...msgs.logoutAgency} />
                        </AgentLogout>
                      </AgentContainer>
                    ) : (
                      <AgentLogging onClick={this.handleAgentLoggin}>
                        <FormattedMessage {...msgs.logginAgency} />
                      </AgentLogging>
                    )}
                  </AgentContainer>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Footer.defaultProps = {
  isAgentLogged: "0",
  affiliate: "",
};
Footer.propTypes = {
  copyright: PropTypes.string,
  isAgentLogged: PropTypes.string,
  affiliate: PropTypes.string,
  showAgentLogin: PropTypes.bool,
};

export default connect(
  createStructuredSelector({
    privacyPolicy: privacyPolicySelector,
    hideDefaultPrivacyPolicy: hideDefaultPrivacyPolicySelector,
  }),
  dispatch => bindActionCreators({}, dispatch)
)(injectIntl(pure(Footer)));
